"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

function HeroHeading() {
  useGSAP(() => {
    // gsap.set(".title", { autoAlpha: 1 });

    SplitText.create(".title", {
      type: "words, chars",
      wordsClass: "word++",
      charsClass: "char",
      mask: "chars",
    });

    const tl = gsap.timeline({
      defaults: { ease: "circ.out", x: "-100%", duration: 0.2, stagger: 0.07 },
    });

    tl.from(".title", { autoAlpha: 0 });

    tl.from(".title .word1 .char", {});

    tl.from(".title .word2 .char", {}, "-=0.15s");

    tl.from(".title .word3 .char", {}, "-=0.15s");

    tl.from(".title .word4 .char", {}, "-=0.15s");

    tl.from(".title .word5 .char", {}, "-=0.15s");
  });

  return (
    <h1 className="title invisible text-5xl font-bold will-change-transform md:text-6xl md:max-w-2xl xl:text-7xl xl:max-w-6xl 2xl:text-8xl 2xl:max-w-350">
      Websites That Work for <span className="text-primary">You</span>
    </h1>
  );
}

export { HeroHeading };
